import React, { useState, useEffect } from 'react';
import { FiBell, FiPlus, FiSave, FiTrash2 } from 'react-icons/fi';

const Banner = () => {
  const [bannerTexts, setBannerTexts] = useState(['']);
  const [bannerColor, setBannerColor] = useState('#2f7690');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/getHomepageBanner');
        const data = await res.json();
        if (data?.texts?.length) {
          setBannerTexts(data.texts);
          setBannerColor(data.color || '#2f7690');
        }
      } catch (err) {
        console.error('Failed to fetch banner config:', err);
        setStatus('Unable to load the current notice.');
      } finally {
        setLoading(false);
      }
    };
    fetchBanner();
  }, []);

  const handleTextChange = (index, value) => {
    const updatedTexts = [...bannerTexts];
    updatedTexts[index] = value;
    setBannerTexts(updatedTexts);
  };

  const handleSave = async () => {
    setStatus('Saving…');
    const payload = { texts: bannerTexts.filter(t => t.trim() !== ''), color: bannerColor };
    try {
      const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/saveHomepageBanner', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Failed to save banner');
      setStatus('Homepage notice saved.');
    } catch (err) {
      console.error('Error saving banner:', err);
      setStatus('The notice could not be saved. Please try again.');
    }
  };

  if (loading) return <div className="dash-card loading-card">Loading homepage notice…</div>;

  return (
    <div className="admin-two-column">
      <section className="dash-card form-card">
        <div className="dash-card-heading">
          <div><span className="dash-card-label">Public homepage</span><h2>Announcement lines</h2></div>
          <FiBell />
        </div>
        <p className="form-help">These messages appear in the colored notice bar below the homepage photo.</p>

        <div className="stacked-fields">
          {bannerTexts.map((text, index) => (
            <div key={index} className="inline-field">
              <label htmlFor={`banner-${index}`}>Line {index + 1}</label>
              <div>
                <input id={`banner-${index}`} type="text" value={text} onChange={(e) => handleTextChange(index, e.target.value)} placeholder="Enter a community notice" />
                {bannerTexts.length > 1 && <button className="icon-button danger" onClick={() => setBannerTexts(bannerTexts.filter((_, i) => i !== index))} aria-label={`Remove line ${index + 1}`}><FiTrash2 /></button>}
              </div>
            </div>
          ))}
        </div>

        <button className="secondary-button" onClick={() => setBannerTexts([...bannerTexts, ''])}><FiPlus /> Add another line</button>

        <div className="color-field">
          <div><label htmlFor="banner-color">Notice color</label><small>This color is used on the live homepage.</small></div>
          <input id="banner-color" type="color" value={bannerColor} onChange={(e) => setBannerColor(e.target.value)} />
        </div>

        <div className="form-actions">
          <button className="primary-button" onClick={handleSave}><FiSave /> Save notice</button>
          {status && <span className="save-status" role="status">{status}</span>}
        </div>
      </section>

      <aside className="dash-card preview-card">
        <span className="dash-card-label">Live preview</span>
        <h2>Homepage notice</h2>
        <div className="banner-preview" style={{ backgroundColor: bannerColor }}>
          <FiBell />
          <strong>Community notice</strong>
          <span>{bannerTexts.filter(Boolean).join(' · ') || 'Your notice will appear here.'}</span>
        </div>
      </aside>
    </div>
  );
};

export default Banner;
